import React from 'react';
import {
	Layout,
	Breakpoints,
	ThemeProvider,
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	TextTag,
} from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

const GuanteraContainer = styled.section<{ isClient: boolean }>`
	background-image: ${(props) =>
		props.isClient
			? 'url(https://assets.volkswagen.com/is/image/volkswagenag/fondo-guantera?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJmRjYzM=)'
			: 'url(https://assets.volkswagen.com/is/image/volkswagenag/servicios-1?Zml0PWNyb3AlMkMxJndpZD0xODM2JmhlaT0xMjI0JmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJjJiYzc=)'};
	background-size: cover;
	background-position-y: ${(props) => !props.isClient && '0'};

	@media screen and (max-width: 959px) {
		background-position-x: ${(props) => (props.isClient ? '0' : '-16rem')};
	}

	@media screen and (min-width: 1600px) {
		background-position-y: ${(props) => !props.isClient && '-5rem'};
	}

	@media screen and (min-width: 1920px) {
		background-position-y: ${(props) => !props.isClient && '-20rem'};
		background-position-x: 0;
	}

	@media screen and (min-width: 2560px) {
		background-position-y: ${(props) => !props.isClient && '-35rem'};
	}
`;

const GuanteraDataListContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	cursor: pointer;
`;

export const Guantera = ({
	children,
	isClient,
}: {
	children: React.ReactElement;
	isClient: boolean;
}): React.ReactElement => {
	return (
		<ThemeProvider theme={'inverted'}>
			<GuanteraContainer isClient={isClient}>
				<Container
					wrap={{ [Breakpoints.default]: 'always', [Breakpoints.b960]: 'never' }}
					padding={{ top: ContainerPadding.dynamic0270, bottom: ContainerPadding.dynamic0270 }}
					stretchContent
				>
					<Layout
						data-testid="guantera-layout"
						appearance={{
							[Breakpoints.default]: [
								{ name: '.', columns: 1 },
								{ name: 'a', columns: 22 },
								{ name: '.', columns: 1 },
								{ name: '.', columns: 1 },
								{ name: 'b', columns: 22 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b960]: [
								{ name: '.', columns: 1 },
								{ name: 'a', columns: 9 },
								{ name: '.', columns: 0 },
								{ name: '.', columns: 1 },
								{ name: 'b', columns: 12 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b1280]: [
								{ name: '.', columns: 1 },
								{ name: 'a', columns: 10 },
								{ name: '.', columns: 0 },
								{ name: '.', columns: 2 },
								{ name: 'b', columns: 10 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b1600]: [
								{ name: '.', columns: 1 },
								{ name: 'a', columns: 9 },
								{ name: '.', columns: 0 },
								{ name: '.', columns: 3 },
								{ name: 'b', columns: 10 },
								{ name: '.', columns: 1 },
							],
						}}
						allowOverflowingContent
					>
						<Container stretchContent>
							<Container stretchContent>
								{isClient ? (
									<Text tag={TextTag.h2} appearance={TokenTextAppearance.headline500}>
										Todo a mano en{' '}
										<Text tag={TextTag.span} appearance={TokenTextAppearance.headline500} bold>
											tu guantera digital
										</Text>
									</Text>
								) : (
									<Text tag={TextTag.h2} appearance={TokenTextAppearance.headline500}>
										Cuando eres de los nuestros,{' '}
										<Text tag={TextTag.span} appearance={TokenTextAppearance.headline500} bold>
											nada puede pararte
										</Text>
									</Text>
								)}
							</Container>
							<Container
								padding={{
									top: {
										[Breakpoints.default]: ContainerPadding.static200,
										[Breakpoints.b1280]: ContainerPadding.dynamic0100,
									},
								}}
								stretchContent
							>
								{isClient ? (
									<Text tag={TextTag.span} appearance={TokenTextAppearance.bigcopy200}>
										Aquí tienes a mano todos tus datos, tus citas y documentos.
									</Text>
								) : (
									<Text tag={TextTag.span} appearance={TokenTextAppearance.bigcopy200}>
										Porque te ayudamos a seguir en movimiento cuando más lo necesitas con nuestros servicios de
										movilidad.
									</Text>
								)}
							</Container>
						</Container>

						<Container
							data-testid="guantera-data-container"
							wrap={'always'}
							horizontalAlign={'space-between'}
							padding={{
								top: {
									[Breakpoints.default]: ContainerPadding.dynamic0130,
									[Breakpoints.b1280]: ContainerPadding.dynamic0050,
								},
							}}
							stretchContent
						>
							<GuanteraDataListContainer className="guantera-data-list-container">{children}</GuanteraDataListContainer>
						</Container>
					</Layout>
				</Container>
			</GuanteraContainer>
		</ThemeProvider>
	);
};
